import React, { Fragment } from 'react';

const LinkHighlighter = ({ text, color }) => {
    // Step 1: Insert a space before every "https://" that follows another
    const cleanedText = text?.replace(/(https?:\/\/)/g, ' $1').trim();

    // Step 2: Regex to find valid URLs
    const urlRegex = /https?:\/\/[^\s]+/g;

    // Step 3: Split the string into parts (links and non-links)
    const parts = cleanedText?.split(/(https?:\/\/[^\s]+)/g);

    return (
        <Fragment>
            {parts.map((part, index) =>
                urlRegex.test(part) ? (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        className='underline italic'
                        style={{ color: color }}
                    >
                        {part}
                    </a>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </Fragment>
    );
};

export default LinkHighlighter;
